import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";

// we will send below data as prop to this componentl

export default function LinChart({ data }) {
  console.log(data);
  if (data == null)
    return (
      <>
        <p>No Data Available</p>
      </>
    );
  return (
    <>
      <div>
        <Line data={data} />
      </div>
    </>
  );
}
